
import global from 'Core/global';
import Block from 'Mixins/Block';
// import analytics from 'Mixins/analytics';
import q from 'Utils/q';
import cookie from 'Libs/cookie/cookie';
import { publish } from 'Mixins/pubsub';


let component = null;
let checkboxAcceptFunctional = null;
let checkboxAcceptStatistics = null;

export default Block('component-cookie', {
	fn: {
		init () {

			if (global.state.acceptedCookiesStatistics) {

				// analytics();

				try {
					$vizzit.cookie.set(); // eslint-disable-line
				} catch (err) { } // eslint-disable-line

			}

			if ((global.state.consentExecuted) || (global.state.acceptedCookiesFunctional || global.state.acceptedCookiesStatistics && !global.state.isInIframe)) {

				// If any of the cookies are set on page load set checkboxes
				if (checkboxAcceptFunctional[0]) {
					checkboxAcceptFunctional[0].checked = global.state.acceptedCookiesFunctional;
				}

				if (checkboxAcceptStatistics[0]) {
					checkboxAcceptStatistics[0].checked = global.state.acceptedCookiesStatistics;
				}

				this.hide();

			} else {

				this.show();

			}

			component.child('.component-cookie__save-and-close').addEvent('click', () => {

				this.hide();

				if (!global.state.isInIframe) {

					this.save();

				}


			});

			q('.component-cookie__edit').addEvent('click', event => {

				event.preventDefault();

				this.show();

				component[0].scrollIntoView({
					behavior: 'smooth'
				});

			});

		},
		save () {

			// Set cookie to confirm that cookie consent has been registered
			cookie.set('FMV_consent_executed', '1', {
				expires: 30
			});

			// Update global state, used by components listening to cookie events
			if (checkboxAcceptFunctional[0]) {
				global.state.acceptedCookiesFunctional = checkboxAcceptFunctional[0].checked;
			}

			if (checkboxAcceptStatistics[0]) {
				global.state.acceptedCookiesStatistics = checkboxAcceptStatistics[0].checked;
			}

			// Save/remove consent to functional cookies
			if (global.state.acceptedCookiesFunctional) {

				cookie.set('FMV_accepted_cookies_functional', '1', {
					expires: 365
				});

			} else {

				cookie.remove('FMV_accepted_cookies_functional');
				cookie.remove('FMV_header_open');

			}

			// Save/remove consent to statistics cookies
			if (global.state.acceptedCookiesStatistics) {

				// analytics();
				try {
					$vizzit.cookie.set(); // eslint-disable-line
				} catch (err) { } // eslint-disable-line

				cookie.set('FMV_accepted_cookies_statistics', '1', {
					expires: 365
				});

			} else {

				cookie.remove('FMV_accepted_cookies_statistics');
				cookie.remove('___vizzit');

			}

			publish('component-cookie-update');

			// location.reload() for init of scripts that have to be inline html to work
			// <script> if (document.cookie.indexOf('FMV_acceptedCookies') > -1) { /*analytics*/ } </script>

		},
		show () {

			component[0].style.height = 'auto';
			component.addClass('component-cookie--visible');

		},
		hide () {

			component[0].style.height = component.outerHeight() + 'px';

			setTimeout(() => {

				component[0].style.height = '0px';
				// component.remove();

			}, 50);

		}
	},
	onLoad (qComponent) {

		component = qComponent;
		checkboxAcceptFunctional = component.child('.component-cookie__accept-functional');
		checkboxAcceptStatistics = component.child('.component-cookie__accept-statistics');

		// Remove legacy accept cookies cookie, can be removed after 2021.
		cookie.remove('FMV_acceptedCookies');

		if (component[0] && checkboxAcceptFunctional[0] || checkboxAcceptStatistics[0]) {

			this.fn.init();

		}

	}
});
